import { GlobalTimePeriodConfig } from 'controls/designer/features/widgets/globalTimeSelector/types';
import { apiFetchObservable, CachedValue } from 'framework/api';
import { getTimeZones } from 'areas/administration/calendar/api';
import { addWidgetExistsValidation, MobxManager, ModelValidator } from 'framework/mobx-integration';
import { makeAutoObservable } from 'mobx';
import { TimePeriodType } from 'controls/react/form/timePeriodType';
import { throttle } from 'lodash';
import { TimePeriod } from 'controls/react/form/timePeriodSelector';
import { Designer } from 'controls/designer/designer';
import { i18n } from './localization';

export type GlobalDashboardTimeSelectorSettings = {
	timezone: string;
	period: TimePeriod;
};

export const AllowedPeriods = [
	TimePeriodType.Last24Hours,
	TimePeriodType.Last7Days,
	TimePeriodType.Last30Days,
	TimePeriodType.Custom,
	TimePeriodType.DynamicInterval,
	TimePeriodType.All,
	TimePeriodType.LastN,
];

export type GlobalTimeSelectorStoreProps<T extends object> = {
	config: GlobalTimePeriodConfig;
	designer?: Designer;
	setValidator?: (formValidator: ModelValidator<T>) => void;
	disableCreation?: boolean;
};

export class GlobalTimeSelectorStore {
	model: GlobalTimePeriodConfig;
	timezones: CachedValue<string[]>;
	designer?: Designer;
	mobx = new MobxManager();
	validator: ModelValidator<GlobalTimePeriodConfig>;
	widgetExists = false;
	constructor(props: GlobalTimeSelectorStoreProps<GlobalTimePeriodConfig>) {
		this.model = props.config;
		this.designer = props.designer;
		this.widgetExists = props.disableCreation;
		this.validator = new ModelValidator(this.model);
		addWidgetExistsValidation(this.validator, () => this.widgetExists, i18n('Widget already exists on dashboard'));
		props.setValidator?.(this.validator);

		makeAutoObservable(this);
		this.timezones = apiFetchObservable(getTimeZones());
		if (this.designer) {
			this.mobx.reaction(
				() => [this.model.period, this.model.timezone],
				() => this.updateTimeSettings(),
			);
		}
	}

	updateTimeSettings = throttle(() => {
		const newSettings = {
			period: this.model.periodEnabled ? this.model.period : undefined,
			timezone: this.model.timeZoneEnabled ? this.model.timezone : undefined,
		};
		if (JSON.stringify(newSettings) == JSON.stringify(this.designer?.store.timeSettings)) {
			return;
		}
		this.designer.store.timeSettings = newSettings;
	}, 500);

	destroy = () => {
		this.mobx.destroy();
	};
}
